<template>
  <BSkeletonWrapper
    :loading="loading"
  >
    <template #loading>
      <BCard
        body-class="p-2"
        class="rounded-lg"
      >
        <BCardText class="p-0">
          <div class="d-flex gap-3">
            <div class="d-flex flex-column flex-grow-1 gap-1">
              <BSkeleton
                width="70%"
                height="14px"
                class="mb-0"
              />
              <div
                class="flex-grow-1 d-flex flex-column justify-content-end gap-1"
                style="margin-top: 1.1rem;"
              >
                <div
                  class="d-flex justify-content-between"
                >
                  <BSkeleton
                    width="20%"
                    height="10px"
                    class="mb-0"
                  />
                  <BSkeleton
                    width="20%"
                    height="10px"
                    class="mb-0"
                  />
                </div>
                <BSkeleton
                  width="100%"
                  height="8px"
                  class="mb-0"
                />
              </div>
            </div>
          </div>
        </BCardText>
      </BCard>
    </template>

    <BCard
      body-class="p-2"
      class="rounded-lg mb-0"
    >
      <BCardText class="p-0">
        <div class="d-flex gap-3">
          <div class="d-flex flex-column flex-grow-1 gap-1">
            <b
              style="font-size: 0.8rem;"
              class="font-weight-bold"
            >
              {{ activity?.activity_name || '' }}
            </b>
            <div class="flex-grow-1 d-flex flex-column justify-content-end gap-1 mt-2">
              <div
                class="d-flex justify-content-between"
                style="font-size: 0.7rem;"
              >
                <div>
                  <b class="text-muted text-primary">{{ activity.valid || 0 }} Valid</b> : <b class="text-muted text-danger">{{ activity.invalid || 0 }} Invalid</b>
                </div>
                <div class="d-flex gap-1">
                  <b class="text-muted">{{ currentProgress.event }}</b> of <b class="text-muted">{{ totalProgress.event }}</b> ,
                  <b :class="`text-${eventVariant}`">{{ eventProgress.toFixed(2) }}%</b>
                </div>
              </div>
              <BProgress
                :max="totalProgress.event"
                height="0.5rem"
              >
                <BProgressBar
                  :value="currentProgress.event"
                  :variant="eventVariant"
                />
              </BProgress>
            </div>
          </div>
        </div>
      </BCardText>
    </BCard>
  </BSkeletonWrapper>
</template>
<script>
import MxFormatter from '@/mixins/formatter'

export default {

  name: 'FSODashboardTermAndAgreement',

  mixins: [
    MxFormatter
  ],

  props: {
    loading: {
      type: Boolean,
      default: () => false
    },
    activity: {
      type: Object,
      required: true,
      default: () => ({
        id: '',
        activity_name: '',
        valid: 0,
        invalid: 0
      })
    },
    totalProgress: {
      type: Object,
      required: true,
      default: () => ({
        event: 0
      })
    },
    currentProgress: {
      type: Object,
      required: true,
      default: () => ({
        event: 0
      })
    }
  },

  computed: {
    eventProgress () {
      const events = this.currentProgress.event / this.totalProgress.event
      if (isNaN(events) || !isFinite(events)) {
        return 0
      }

      return events * 100
    },

    eventVariant () {
      if (this.eventProgress >= 75) {
        return 'success'
      } else if (this.eventProgress >= 31) {
        return 'warning'
      } else if (this.eventProgress >= 0.01) {
        return 'danger'
      } else {
        return 'dark'
      }
    }
  },

  methods: {
    variant () {
      // todo: create officer
    }
  }
}
</script>
